import { Box, Icon, Text, TextLink } from '@factorialco/deprecated-design-system'
import { TrainingMembershipFileFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  trainingMembershipFiles: TrainingMembershipFileFragment[]
  trainingId: number
}

export const CertificateProjection = ({ trainingMembershipFiles, trainingId }: Props) => {
  const { navigation } = useNavigation()
  const { access } = useCurrentSession()
  const file = trainingMembershipFiles[0]
  if (!file) return null

  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Box>
        <Icon.Medium icon="file-filled" color="grey800" />
      </Box>
      <TextLink
        onClick={() => track(trackingEvents.training.trainingWorkflows.goToCertificateDatatable)}
        to={navigation.trainings.list.details_revamp.view.participants.employees.previewCertificate.fullPath(
          {
            id: Number(trainingId),
            employeeId: access.id,
            trainingMembershipId: file.trainingMembershipId,
            trainingMembershipFileId: file.id,
          }
        )}
      >
        <Text.Normal underlined>
          {trainingMembershipFiles.length === 1
            ? `${trainingMembershipFiles.length} ${i18n.t(
                'trainings.trainings_revamp.training_detail.employees_table.file'
              )}`
            : `${trainingMembershipFiles.length} ${i18n.t(
                'trainings.trainings_revamp.training_detail.employees_table.files'
              )}`}
        </Text.Normal>
      </TextLink>
    </Box>
  )
}
